import { render, staticRenderFns } from "./transactionRecords.vue?vue&type=template&id=39c3a686&scoped=true"
import script from "./transactionRecords.vue?vue&type=script&lang=js"
export * from "./transactionRecords.vue?vue&type=script&lang=js"
import style0 from "./transactionRecords.vue?vue&type=style&index=0&id=39c3a686&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c3a686",
  null
  
)

export default component.exports